import { useAtom } from 'jotai';
import { useRef } from 'react';

import { ContactInnovationTeamForm } from '@/features/contact-innovation-team/contact-innovation-team-form';
import type { SpotlightContactFormCloseTracking } from '@/features/spotlight/tracking/use-spotlight-contact-form-tracking';
import { modalState } from '@/state/modal.state';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Modal } from '@/ui/modal/modal';

export const ContactInnovationTeamModal = () => {
  const [modal, setModal] = useAtom(modalState);
  const closeTrackingRef = useRef<SpotlightContactFormCloseTracking | null>(
    null,
  );

  const closeModal = () => {
    closeTrackingRef.current?.trackAbandoned();
    setModal(null);
  };

  if (!modal || modal.state !== 'contactInnovationTeam') {
    return null;
  }

  return (
    <Modal onClose={closeModal} minWidth="580px">
      <Flexbox alignItems="center" fullWidth justify="center">
        <ContactInnovationTeamForm
          accountName={modal.accountName}
          closeTrackingRef={closeTrackingRef}
          companyName={modal.companyName}
          organizationId={modal.organizationId}
          useSpotlightInquiry={modal.useSpotlightInquiry}
        />
      </Flexbox>
    </Modal>
  );
};
